<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card style="width:95vw">
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="isLoading">
                    <mat-spinner></mat-spinner>
                    <h2>Loading Report Details...</h2>
                </div>
                <div *ngIf="!isLoading && !errorMessage && !pdfUrl">
                    <h2>Report Verification</h2>
                    <p>Please wait while we verify the report details.</p>
                </div>
                <div *ngIf="errorMessage">
                    <h2>Report Verification Failed</h2>
                    <p>{{ errorMessage }}</p>
                </div>

                <ng-container *ngIf="pdfUrl">
                    <div class="report-note">
                        <span>
                            <strong>Attention: </strong>This preview shows the report <strong>exactly</strong> as
                            it was originally created. This is an authentic MedicAI statistics report that can be
                            verified using the QR code embedded in the document.
                        </span>
                    </div>

                    <ngx-extended-pdf-viewer [src]="rawPdfUrl" [useBrowserLocale]="true" width="100%"
                        [showDownloadButton]="false" [showPrintButton]="false" [showPresentationModeButton]="false"
                        [showOpenFileButton]="false" [showPagingButtons]="false" [showFindButton]="false"
                        [showZoomButtons]="true"></ngx-extended-pdf-viewer>
                </ng-container>

            </mat-card-content>
        </mat-card>
    </div>
</div>
